import React from '../helpers/react';
import {connect} from '../helpers/composeReducer.js';
import {tocToggleChapter} from '../actions/toc.action';
import {pushPath} from 'redux-simple-router';
import classList from 'ereader-core/dist/classList.js';
import {getIdentifier} from '../helpers/api.js';
import { enableTitleChange } from "../actions/model.action.js";

export const Chapter = React.createClass({
    toggleChapter : function(){
        this.props.tocToggleChapter(this.props.chapterId);
    },
    render : function(){
        let chapter = this.props.chapters[this.props.chapterId];
        let opened = this.props.opened_chapter == this.props.chapterId;
        let problems = [];
        if (opened && chapter.problems.map) {
            problems = chapter.problems.map((problem)=>{
                let classes = ['problem'];
                let id = getIdentifier(this.props.app_id, chapter, problem);

                if (this.props.problem_id == id) classes.push('current');
                let bookMarkHtml = '';
                if(this.props.show_bookmark && problem.isBookmarked) {
                  classes.push('bookmarked');
                  const bookMarkIcon = "Book Mark Icon " + problem.problemName;
                  bookMarkHtml = <span className='bookmarkedUnique' role="img" aria-label={bookMarkIcon}></span>;
                }

                return <li
                    className={classes.join(' ')}
                    data-id={problem.problemName}
                    key={`${this.props.chapterId}-${problem.problemName}`}
                    onClick={()=>this.openProblem(chapter, problem)}
                    tabIndex="0"
                    role="button"
                    aria-label={"Problem " + problem.problemName}
                    onKeyDown={(e)=>this.keyDownProblemName(e, chapter, problem)}
                >{bookMarkHtml}{problem.problemName}</li>;
            });
        }

        let name = this.props.getDef('toc.chapter.name', {name : chapter.chapterName});

        let classes = classList('chapter');
        if (opened) classes.push('open');
        if (this.props.isFixed) classes.push('fixed');
        if (this.props.current_chapter.chapterId == this.props.chapterId) classes.push('current');

        return <li className={`chapter-list-toc ${classes}`} data-id={this.props.chapterId}>
            <h2 onClick={this.toggleChapter}
                tabIndex="0"
                aria-haspopup="true"
                role="button" aria-pressed={opened}
                onKeyDown={(e)=>this.keyDownChapter(e)}
                className = "chapter-current"
            >{name}</h2>
            <ol className='problems'>{problems}</ol>
        </li>
    },
    keyDownChapter: function(e) {
        const is_opened = (this.props.opened_chapter == this.props.chapterId);

      // # Accessibility -- let element respond to Tab
        let chapter_length = this.props.chapter_stack.length;
        if(e.keyCode === 9 && !e.shiftKey && this.props.chapters[this.props.chapterId].chapterName == this.props.chapter_stack[chapter_length-1].chapterName) {
            if(!is_opened) {
              e.preventDefault();
              if (!this.props.show_mobile && !this.props.show_bookmark) document.getElementById('show-all-steps').focus();
              else if (!this.props.show_mobile) document.getElementById('bookmark-tab').focus();
              else document.getElementById('mobile-tab').focus();
            }
        }
        // # Accessibility -- let chapter in TOC respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let element respond to Shift + Tab
        if(e.shiftKey && e.keyCode === 9 && this.props.chapters[this.props.chapterId].chapterName == this.props.chapter_stack[0].chapterName) {
            e.preventDefault();
            document.getElementById('toc-button').focus();
        }
    },
    keyDownProblemName: function(e, chapter, problem) {
        // # Accessibility -- let problem name in TOC respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let last element respond to Tab
        if (e.currentTarget.nextElementSibling == null) {
            if(e.keyCode === 9) {
                e.preventDefault();
                if (!this.props.show_mobile && !this.props.show_bookmark) document.getElementById('show-all-steps').focus();
                else if (!this.props.show_mobile) document.getElementById('bookmark-tab').focus();
                else document.getElementById('mobile-tab').focus();
            }
        }
    },
    openProblem : function(chapter, problem){
        let chapter_identifier = chapter[this.props.use_ids ? 'chapterId' : 'chapterName'];
        let problem_identifier = problem[this.props.use_ids ? 'problemId' : 'problemName'];
        this.props.enableTitleChange();
        this.props.pushPath(this.props.buildRoute('problem',{
            chapter : chapter_identifier,
            problem : problem_identifier,
            isbn13  : this.props.isbn13
        }));

    }
})

export function matchProps(state){
    return {
        chapters : state.toc.chapters,
        chapter_stack: state.toc.chapter_stack,
        opened_chapter : state.toc.opened_chapter,
        current_chapter : state.problem.chapter,
        problem_id : state.problem.identifier,
        use_ids : state.options.use_id_identifier,
        isbn13 : state.model.isbn13,
        app_id : state.app.id,
        buildRoute : state.helpers.buildRoute,
        getDef : state.helpers.getDef,
        show_bookmark : state.options.show_bookmark,
        show_mobile : state.options.show_mobile
    };
}

export default connect(matchProps, {
    tocToggleChapter,
    pushPath,
    enableTitleChange
})(Chapter)



// WEBPACK FOOTER //
// ./src/components/TOC.Chapter.js